// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import React from "react";
import styles from './deliveryPhoto.module.scss';
import ImagePopup from "./imagePopup";

interface Props {
    url: string
}
const DeliveryPhoto: React.FC<Props> = ({ url }) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => { setOpen(false); };
    const handleOpen = () => { setOpen(true); };
    return (
        <>
            <div className={styles.delivery_photo}>
                <Button onClick={handleOpen}>
                    <img src="/photo-camera.svg" alt="" width={20} height={20} />
                    Check Verification Photo
                </Button>
            </div>
            <ImagePopup url={url} open={open} handleClose={handleClose} />
        </>
    )
}
export default DeliveryPhoto;